
import payments from "../../../pages/Financials/payments";
import {
    LOG_OUT_USER,
    FETCH_PAYMENTS,
    ADD_PAYMENT,
    UPDATE_PAYMENT,
    DELETE_PAYMENTS,
    SEND_PAYMENT_RECEIPT,
    ASSIGN_PAYMENT,
    REALLOCATE_PAYMENT
 } from "../../actions/actionTypes";


const fetchPaymentsReducer = (payments, payload) => {
    let newPayments = payload.offset == "" ? {} : { ...payments };
    for(let payment of payload.payments){
        newPayments[payment.paymentId] = payment;
    }
    return newPayments;
}

const addPaymentReducer = (payments, payload) => {
    let newPayments = {
        ...payments,
        [payload.payment.paymentId]: {...payload.payment}
    };
    return newPayments;
}

const updatePaymentReducer = (payments, payload) => {
    let newPayments = {
        ...payments,
        [payload.payment.paymentId]: {
            ...payments[payload.paymentId],
            ...payload.payment
        }
    };
    return newPayments;
}

const deletePaymentsReducer = (payments, payload) => {
    let newPayments = { ...payments };
    for (const paymentId of payload.paymentIds) {
      delete newPayments[paymentId];
    }
    return newPayments;
  }

const sendPaymentReceiptSMSReducer = (payments, payload) => {
    let newPayments = { ...payments };
    for(let payment of payload.payments){
        newPayments[payment.paymentId] = {
            ...payments[payment.paymentId],
            ...payment
        };
    }
    return newPayments;
    };


const assignPaymentReducer = (payments, payload) => {
    let newPayments;
    //unassignedFilter ensures a payment is removed from the payments list after it has been assigned to a tenant.
    //if the filter has not been selected, it will not be removed
    if (!payload.unassignedFilter){
        newPayments = {
            ...payments,
            [payload.paymentId]: {
                ...payments[payload.paymentId],
                tenant: payload.payment.tenant,
                tenantId: payload.payment.tenantId? payload.payment.tenantId : "",
            }
        };
    } else{
        newPayments = { ...payments};
        delete newPayments[payload.paymentId];
    }
    return newPayments;
}

const reallocatePaymentReducer = (payments, payload) => {
    let newPayments;
    newPayments = {
        ...payments,
        [payload.paymentId]: {
            ...payments[payload.paymentId],
            tenant: payload.payment.tenant,
            tenantId: payload.payment.tenantId? payload.payment.tenantId : "",
        }
    };

    return newPayments;
}


const paymentsReducer = (state={}, action) => {
    let payments = state;
    if (action && action.payload && !action.errors && !action.payload.errors){
        switch(action.type){
            case FETCH_PAYMENTS:
                return fetchPaymentsReducer(payments, action.payload);
            case ADD_PAYMENT:
                return addPaymentReducer(payments, action.payload);
            case UPDATE_PAYMENT:
                return updatePaymentReducer(payments, action.payload);
            case DELETE_PAYMENTS:
                return deletePaymentsReducer(payments, action.payload);
            case SEND_PAYMENT_RECEIPT:
                return sendPaymentReceiptSMSReducer(payments, action.payload);
            case ASSIGN_PAYMENT:
                return assignPaymentReducer(payments, action.payload);
            case REALLOCATE_PAYMENT:
                return reallocatePaymentReducer(payments, action.payload);
            case LOG_OUT_USER:
                return {};
            default:
                return payments
        }
    }
    return payments;
}

export default paymentsReducer;